import {DialogueParticipants} from './DialogueParticipants';
export default DialogueParticipants;
